<template>

  <t-page>

    <t-dialog-ordained @hidden="getPage"
                       primary-key-column="checklistStatusId"
                       foreign-key-column="onlaineId"
                       v-if="modalOrdained"
                       :path="currentPage.path"
                        />

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>

        <t-button v-if="userAuth.validation.validationCreate || userAuth.validation.validationUpdate" :text="'Alterar Ordem'"
                  @click="openDialogOrdained()" />

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <t-msg info>Utilize o status operacional da inspeção, caso desejar controlar o andamento da forma desejada, porém não é obrigatório o uso.
        Caso possuir registros, será considerado o primeiro status da fila nas inclusões de inspeções</t-msg>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               primary-key-column="checklistStatusNumber" link-primary-column="name">

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogOrdained from "@/components/template/dialog/t-dialog-ordained";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogOrdained},
  name: 'TypeChecklistStatus',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "name", label: "Status Inspeção"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'checklist-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
